"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variationsV1 = exports.deleteOne = exports.postOne = exports.duplicateVariation = exports.updateOne = void 0;
const updateOne = (caller) => (options) => caller(`/accounts/${options.accountId}/tests/${options.testId}/variations/${options.variationId}`).patch(options.payload);
exports.updateOne = updateOne;
const duplicateVariation = (caller) => ({ accountId, testId, variationId }) => {
    return caller(`/accounts/${accountId}/tests/${testId}/variations`).post({ variation_id: variationId });
};
exports.duplicateVariation = duplicateVariation;
const postOne = (caller) => ({ accountId, testId }) => caller(`/accounts/${accountId}/tests/${testId}/variations`).post();
exports.postOne = postOne;
const deleteOne = (caller) => ({ accountId, testId, variationId }) => caller(`/accounts/${accountId}/tests/${testId}/variations/${variationId}`).delete();
exports.deleteOne = deleteOne;
const variationsV1 = (caller) => ({
    updateOne: (0, exports.updateOne)(caller),
    duplicateVariation: (0, exports.duplicateVariation)(caller),
    postOne: (0, exports.postOne)(caller),
    deleteOne: (0, exports.deleteOne)(caller),
});
exports.variationsV1 = variationsV1;
//# sourceMappingURL=apiV1.js.map